import React, { useEffect, useState } from "react";
import { apiWrapper } from "../apis/CommonApi";
import * as accountApi from "../apis/AccountApi";
import {
  GeneralUserTypeChoice,
  UserAuthorityChoice,
  getGeneralUserTypeName,
  getUserAuthorityName,
} from "../utils/common";
import { useNavigate } from "react-router-dom";
import PageHeader from "../components/PageHeader";

export default function JoinPage() {
  const navigate = useNavigate();
  const [isIdAvailable, setIdAvailable] = useState(false); // ID 사용 가능 여부
  const [isPasswordMatch, setPasswordMatch] = useState(false); // 비밀번호 일치 여부
  const [isCompletedPassword, setCompletedPassword] = useState(false); // 비밀번호 입력 완료 여부
  const [isCompletedPasswordConfirm, setCompletedPasswordConfirm] =
    useState(false); // 비밀번호 확인 입력 완료 여부
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    setFormDataProperty("userAuthority", UserAuthorityChoice.BUSINESS);
    setFormDataProperty("userId", "");
    setFormDataProperty("password", "");
    setFormDataProperty("passwordConfirm", "");
    setFormDataProperty("userName", "");
    setFormDataProperty("title", "");
    setFormDataProperty("phoneNumber", "");
    setFormDataProperty("email", "");
    setFormDataProperty("businessNumber", "");
    setFormDataProperty("userType", GeneralUserTypeChoice.FIRE_SAFETY_ADMIN);
  }, []);

  const setFormDataProperty = (name, value) => {
    setFormData((currentFormData) => {
      const nextFormData = {
        ...currentFormData,
        [name]: value,
      };
      //console.log(nextFormData);
      return nextFormData;
    });
  };

  const onChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setFormDataProperty(name, value);
  };

  const handleCheckDuplicate = () => {
    if (formData.userId === "") {
      alert(`아이디를 입력해주세요.`);
    } else {
      apiWrapper(async () => {
        let result = await accountApi.checkDuplicateId(formData.userId);

        const { status, data } = result;
        if (status === true) {
          setIdAvailable(true);
        } else {
          setIdAvailable(false);
          alert(`${data}`);
        }
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else if (checkValid() === false) {
      e.stopPropagation();
    } else {
      apiWrapper(async () => {
        let requestBody = {
          userData: {
            userId: formData.userId,
            password: formData.password,
            userName: formData.userName,
            phoneNumber: formData.phoneNumber.trim().replace(/-/g, ""),
            email: formData.email,
          },
        };

        if (formData.userAuthority === UserAuthorityChoice.BUSINESS) {
          //사업자
          requestBody = {
            ...requestBody,
            businessData: {
              businessNumber: formData.businessNumber,
            },
          };
        } else if (formData.userAuthority === UserAuthorityChoice.GENERAL) {
          //사용자
          requestBody = {
            ...requestBody,
            generalData: {
              userType: formData.userType,
              title: formData.title,
            },
          };
        }

        const { status, data } = await accountApi.join(requestBody);
        alert(`${data}`);

        if (status === true) {
          navigate("/");
        }
      });
    }
  };

  const checkValid = () => {
    if (isIdAvailable === false) {
      alert("아이디를 확인해주세요.");
    } else if (isPasswordMatch === false) {
      alert("패스워드를 확인해주세요.");
    }

    return true;
  };

  const handleCheckPasswordMatch = () => {
    if (formData.password === formData.passwordConfirm) {
      setPasswordMatch(true);
    } else {
      setPasswordMatch(false);
    }
  };

  return (
    <section class="mbSection">
      <PageHeader isBlack={false} title="회원가입" isUseMenu={false} />
      <form onSubmit={handleSubmit}>
        {formData && (
          <div class="container pb-40">
            <div class="input-wrap input-join-wrap">
              <div class="input-item">
                <p class="input-title">구분</p>
                <div class="radio-group">
                  {/* "전체" 상태는 제외하고 전시 */}
                  {Object.values(UserAuthorityChoice).map((item, index) =>
                    index === 0 ? null : (
                      <>
                        <input
                          type="radio"
                          id={`userAuthority${item}`}
                          name="userAuthority"
                          value={item}
                          checked={formData.userAuthority === item}
                          onChange={onChange}
                        />
                        <label htmlFor={`userAuthority${item}`}>
                          {getUserAuthorityName(item)}
                        </label>
                      </>
                    )
                  )}
                </div>
              </div>
              <div class="input-item">
                <p class="input-title">아이디</p>
                <div class="input-inner-wrap">
                  <input
                    class="defaultInput"
                    type="text"
                    placeholder="아이디를 입력해주세요."
                    name="userId"
                    value={formData.userId}
                    onChange={onChange}
                    required
                  />
                  {isIdAvailable === false && (
                    <button
                      type="button"
                      class="btn-verify"
                      onClick={handleCheckDuplicate}
                    >
                      중복확인
                    </button>
                  )}
                  {isIdAvailable && (
                    <p class="verify-chk-txt">
                      <i class="x-icon"></i>사용가능
                    </p>
                  )}
                </div>
              </div>
              <div class="input-item">
                <p class="input-title">비밀번호</p>
                <div class="input-inner-wrap input-duble-wrap">
                  <input
                    class="defaultInput"
                    type="password"
                    placeholder="비밀번호를 입력해주세요."
                    name="password"
                    value={formData.password}
                    onChange={onChange}
                    onBlur={() => {
                      formData.password
                        ? setCompletedPassword(true)
                        : setCompletedPassword(false);
                      handleCheckPasswordMatch();
                    }}
                    required
                  />
                  <input
                    class="defaultInput"
                    type="password"
                    placeholder="비밀번호를 다시 입력해주세요."
                    name="passwordConfirm"
                    value={formData.passwordConfirm}
                    onChange={onChange}
                    onBlur={() => {
                      formData.passwordConfirm
                        ? setCompletedPasswordConfirm(true)
                        : setCompletedPasswordConfirm(false);
                      handleCheckPasswordMatch();
                    }}
                    required
                  />
                </div>
                {/* <p class="input-guide-txt">
                  비밀번호의 글자나 특수문자 등 제한을 두신다면 여기에
                  작성해주세요.
                </p> */}
                {isCompletedPassword &&
                  isCompletedPasswordConfirm &&
                  isPasswordMatch === false && (
                    <p class="input-guide-txt red">
                      비밀번호가 일치하지 않습니다.
                    </p>
                  )}
              </div>
              <div class="input-item">
                <p class="input-title">사용자 이름</p>
                <div class="input-inner-wrap">
                  <input
                    class="defaultInput"
                    type="text"
                    placeholder="사용자 이름을 입력해주세요."
                    name="userName"
                    value={formData.userName}
                    onChange={onChange}
                    required
                  />
                </div>
              </div>
              {formData.userAuthority === UserAuthorityChoice.GENERAL && (
                <div class="input-item">
                  <p class="input-title">직함/직책</p>
                  <div class="input-inner-wrap">
                    <input
                      class="defaultInput"
                      type="text"
                      placeholder="직함/직책을 입력해주세요."
                      name="title"
                      value={formData.title}
                      onChange={onChange}
                      required
                    />
                  </div>
                </div>
              )}
              <div class="input-item">
                <p class="input-title">휴대폰 번호</p>
                <div class="input-inner-wrap">
                  <input
                    class="defaultInput"
                    type="text"
                    placeholder="휴대폰 번호를 입력해주세요."
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={onChange}
                    required
                  />
                </div>
              </div>
              <div class="input-item">
                <p class="input-title">이메일</p>
                <div class="input-inner-wrap">
                  <input
                    class="defaultInput"
                    type="text"
                    placeholder="이메일을 입력해주세요."
                    name="email"
                    value={formData.email}
                    onChange={onChange}
                    required
                  />
                </div>
              </div>
              {formData.userAuthority === UserAuthorityChoice.BUSINESS && (
                <div class="input-item input-busines">
                  <p class="input-title">사업자 번호</p>
                  <div class="input-inner-wrap">
                    <input
                      class="defaultInput"
                      type="text"
                      placeholder="'-' 제외 숫자 10자리"
                      name="businessNumber"
                      value={formData.businessNumber}
                      onChange={onChange}
                      required
                    />
                  </div>
                </div>
              )}
              {formData.userAuthority === UserAuthorityChoice.GENERAL && (
                <div class="input-item">
                  <p class="input-title">사용자 구분</p>
                  <div class="radio-group col">
                    {Object.values(GeneralUserTypeChoice).map((item, index) => (
                      <>
                        <input
                          type="radio"
                          key={index}
                          id={`userType${item}`}
                          name="userType"
                          value={item}
                          checked={formData.userType === item}
                          onChange={onChange}
                        />
                        <label htmlFor={`userType${item}`}>
                          {getGeneralUserTypeName(item)}
                        </label>
                      </>
                    ))}
                  </div>
                  <div class="input-guide-wrap">
                    <span>※</span>
                    <p class="input-guide-txt">
                      소방안전관리자 및 보조안전관리자는 소방대상물{" "}
                      <span class="bold">
                        신규 등록/수정 및 화재수신기 원격제어가 가능
                      </span>
                      합니다.
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        <div class="btmBtnWrap">
          <button
            type="button"
            class="btn btn-grey"
            onClick={() => navigate(-1)}
          >
            취소
          </button>
          <button type="submit" class="btn btn-black">
            가입
          </button>
        </div>
      </form>
    </section>
  );
}
